import { TSourceCard } from "types/SourceTypes";
import { isNull } from "lodash";

export function isCardSorted(card: TSourceCard) {
  return !isNull(card.isInMyDeck);
}

export const startFasterCurve = "cubic-bezier(0, 0.3, 1, 1)";
